import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { HttpClientModule } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgForageModule, NgForageConfig } from 'ngforage';
import { reducers, metaReducers } from './store';
import { TrapFocusDirective} from "./helper/trapfocus/trap-focus.directive";


import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { PageNotFoundComponent } from './screens/page-not-found/page-not-found.component';
import { HeaderComponent } from './components/header/header.component';
import { PrestationComponent } from './screens/prestation/prestation.component';
import { RegisterComponent } from './screens/register/register.component';
import { InviteFriendComponent } from './screens/invite-friend/invite-friend.component';
import { CoreService } from './helper/core/core.service';
import { Constant } from './helper/core/constant';
import { loaderHttpInterceptorProviders } from './helper/core/loader/loader-interceptor';
import { apiHttpInterceptorProviders } from './helper/core/api/api-interceptor';
import { LoaderComponent } from './helper/core/loader/loader.component';
import { LoaderService } from './helper/core/loader/loader.service';
import { BuNameService } from './helper/core/bu-name.service';
import { UnsubscribeComponent } from './screens/unsubscribe/unsubscribe.component';
import { UserService } from './helper/core/user.service';
import { FilterService } from './helper/core/filter.service';
import { QuotePipe } from './helper/core/quote.pipe';
import { UtilsService } from './helper/utils/utils.service';
import { FooterComponent } from './components/footer/footer.component';
import { LegalnoticesComponent } from './screens/legalnotices/legalnotices.component';
import { FormVoluntaryComponent } from './screens/form-voluntary/form-voluntary.component';
import { RgaaSelectComponent } from './components/rgaa-select/rgaa-select.component';
import { LieuComponent } from './todo_remove/lieu/lieu.component';
import { DateComponent } from './todo_remove/date/date.component';
import { RegisterEventModule } from "./screens/register-event/register-event.module";
import { SharedModule } from "./helper/shared/shared.module";
import { HideOnEventDirective } from './helper/directives/hide-on-event.directive';
import { EqualizerDirective } from './helper/directives/equalizer.directive';
import { EqualizerModule } from './helper/equalizer/equalizer.module';
import { SearchComponent } from './screens/search/search.component';
import { FragmentCheckerService } from './helper/utils/fragment-checker.service';
import { ConfigService } from './config.service';


@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    HeaderComponent,
    FooterComponent,
    PrestationComponent,
    LieuComponent,
    SearchComponent,
    DateComponent,
    RegisterComponent,
    InviteFriendComponent,
    LoaderComponent,
    UnsubscribeComponent,
    QuotePipe,
    FooterComponent,
    LegalnoticesComponent,
    FormVoluntaryComponent,
    RgaaSelectComponent,
    HideOnEventDirective,
    EqualizerDirective,
    TrapFocusDirective
  ],
  imports: [
    BrowserModule,
    StoreModule.forRoot(reducers, {metaReducers}),
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    NgForageModule.forRoot(),
    RegisterEventModule,
    SharedModule,
    EqualizerModule
  ],
  providers: [
    CoreService,
    Constant,
    loaderHttpInterceptorProviders,
    apiHttpInterceptorProviders,
    LoaderService,
    BuNameService,
    UserService,
    FilterService,
    UtilsService,
    FragmentCheckerService,
    ConfigService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  public constructor(
    ngfConfig: NgForageConfig
  ) {
    ngfConfig.configure({
      name: 'OrangeBrandFlow',
      cacheTime: 3600000,
      driver: [ // defaults to indexedDB -> webSQL -> localStorage -> sessionStorage
        NgForageConfig.DRIVER_INDEXEDDB,
        NgForageConfig.DRIVER_WEBSQL,
        NgForageConfig.DRIVER_LOCALSTORAGE,
        NgForageConfig.DRIVER_SESSIONSTORAGE
      ]
    });

  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts